@if (activeConfig) {
  <div class="modal-content" role="dialog" aria-modal="true" data-testid="modal-dialog">
    @if (activeConfig.message) {
      <p class="modal-message" data-testid="modal-message">{{ activeConfig.message }}</p>
    }
    
    @if (activeConfig.type === 'prompt') {
      <div class="modal-input-group">
        @if (activeConfig.inputLabel) {
          <label class="modal-label" for="modal-input" data-testid="modal-label">
            {{ activeConfig.inputLabel }}
          </label>
        }
        <input
          #inputEl
          type="text"
          id="modal-input"
          class="modal-input"
          [ngModel]="inputValue"
          (ngModelChange)="onInputValueChange($event)"
          [placeholder]="activeConfig.inputPlaceholder || ''"
          (keydown.enter)="onConfirm()"
          (keydown.escape)="onCancel()"
          data-testid="input-modal"
        />
      </div>
    }
  </div>
}
